var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuicklink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "18px",
    viewBox: "0 0 9 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd70f",
    d: "M10,7.993a1.6,1.6,0,0,1-.359.85l-.419.593-5.728,8.1a.929.929,0,0,1-.764.457.9.9,0,0,1-.71-.38,1.038,1.038,0,0,1-.2-.62,1.411,1.411,0,0,1,.137-.537l.13-.318c.071-.175,2.1-5.145,2.113-5.145-.289,0-3.047.016-3.335,0A.978.978,0,0,1,0,10.084,1.739,1.739,0,0,1,.5,8.942L6.224.856A3.41,3.41,0,0,1,6.763.175.865.865,0,0,1,8.042.446a1.76,1.76,0,0,1-.18,1.583L5.934,6.993H8.488a2.247,2.247,0,0,1,1,.1.959.959,0,0,1,.5.746A.945.945,0,0,1,10,7.993Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuicklink);
export default __webpack_public_path__ + "static/media/quicklink.2aad8800e49c5ae764fdf76dcdc591d9.svg";
export { ForwardRef as ReactComponent };